export default __webpack_public_path__ + "static/network-1-be28df00e349ac7b1a21d5d2d0e5327e.png";